import { OrganizationScopeSchema } from 'notable-common';
import { z } from 'zod';
import { OmniFieldDefinitionSchema } from './omni/fields.js';
import { OmniQueryOptionsSchema } from './omni/queryOptions.js';
export const analyticsQueryLimits = { rows: 1_000 };
const AnalyticsTimeZoneSchema = z
    .string()
    .min(1)
    .max(100)
    .refine((timeZone) => {
    try {
        Intl.DateTimeFormat(undefined, { timeZone });
        return true;
    }
    catch {
        return false;
    }
}, { message: 'Invalid IANA time zone identifier' });
export const AnalyticsQuerySchema = OmniQueryOptionsSchema.extend({
    organizationIds: OrganizationScopeSchema.describe('Explicit organization IDs or allAuthorized.'),
    timeZone: AnalyticsTimeZoneSchema.describe('IANA timezone for calendar grouping and date/time interpretation. Absolute datetime bounds retain the instant specified by their offset.'),
    limit: z
        .number()
        .int()
        .min(1)
        .max(analyticsQueryLimits.rows)
        .default(100)
        .describe('Maximum returned rows, not a page size or limit on data examined. Narrow filters or grouping when truncated.'),
});
export const AnalyticsQueryResponseSchema = z.strictObject({
    rows: z
        .array(z.record(z.string(), z.json()))
        .max(analyticsQueryLimits.rows)
        .describe('Long-form records keyed by discovered field identifiers, including for pivot queries. 64-bit integer columns, including small counts, and decimal columns are exact decimal strings; dates are YYYY-MM-DD; timestamps retain fractional precision and use Z only when timezone-aware; binary values are base64. Nested values and nulls are preserved.'),
    fieldMetadata: z
        .array(OmniFieldDefinitionSchema)
        .describe('Metadata from the executed query for the returned columns, in selection order.'),
    truncation: z
        .literal('rowLimit')
        .nullable()
        .describe('Response row truncation. Null means no rows were truncated from the response, not that results cover the entire population. Request aggregate totals and weighted averages rather than deriving them from bounded detail rows.'),
    scope: z.strictObject({
        organizationIds: z.array(z.uuid()).min(1),
        timezone: AnalyticsTimeZoneSchema,
        filters: AnalyticsQuerySchema.shape.filters
            .unwrap()
            .describe('Applied filters in request format after organization scoping. Does not include implicit access restrictions or establish complete coverage.'),
    }),
    retrievedAt: z.iso.datetime().describe('Query completion time, not source freshness.'),
});
//# sourceMappingURL=query.js.map